import { render } from "./404.vue?vue&type=template&id=0a6fd6be"
import script from "./404.vue?vue&type=script&lang=js"
export * from "./404.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ianlueninghoener/Documents/development/ianlueninghoener.com/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render]])